import axios from "axios";
import { getLs, setLs, baseUrl } from ".";
import { toast } from "react-hot-toast";

axios.defaults.baseURL = `${baseUrl}`;
axios.defaults.headers.common["X-Requested-With"] = `XMLHttpRequest`;

const refreshUserActivity = () => {
  try {
    if (getLs("billnote_logged") === "yes") {
      setLs("billnote_last_activity", Date.now().toString());
    }
  } catch (e) {
    // Ignore storage errors if any
  }
};

axios.interceptors.request.use(
  (config) => {
    refreshUserActivity();
    const token = getLs("billnote_api");
    if (token) {
      config.headers["Api-Token"] = token;
    }
    return config;
  },
  (error) => {
    refreshUserActivity();
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    refreshUserActivity();
    return response;
  },
  (error) => {
    refreshUserActivity();
    const userMessage =
      error.response?.data?.message || "An unexpected error occurred. Please try again.";
    toast.error(userMessage, {
      duration: 4000,
    });
    throw error;
  }
);

const Api = axios.create();

export default Api;

